import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import srcRobotoItalic from '../../../assets/custom/font/roboto/Roboto-Italic.ttf';
import { useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
import MasterService from "../../../services/master/MasterService";
import { formatDateStringLocalDate } from "../../../utilities/Utils";
import imgCheck from "../../../assets/images/icons/check.png"
import GetDokumen from "../../../utilities/GetDokumen";
import DraftAppendix from "../draft/DraftAppendix";
import Kemasan from "../../../utilities/Kemasan";

Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 215,
        paddingBottom: 48,
        paddingHorizontal: 48,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingEn: {
        fontSize: 8,
        textAlign: "center",
        textDecoration: "underline"
    },
    headingIn: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    headingRow: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap"
    },
    heading: {
        fontSize: 9,
        textAlign: "center"
    },
    headingItalic: {
        fontFamily: "Roboto-Italic",
        fontSize: 9,
        textAlign: "center"
    },
    textHeading: {
        fontSize: 8,
        textAlign: "center"
    },
    textHeadingItalic: {
        fontFamily: "Roboto-Italic",
        fontSize: 8,
        textAlign: "center",
        marginBottom: 3
    },
    headingBetween: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 0,
    },
    tableNoBorder: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        width: "50%",
        borderStyle: "solid",
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 3,
    },
    tableColNoPadding: {
        width: "50%",
        borderStyle: "solid",
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    text: {
        fontSize: 7,
    },
    italicText: {
        fontFamily: "Roboto-Italic",
        fontSize: 7,
    },
    checkicon: {
        width: 12,
        height: 12
    },
    sectionHeader: {
        paddingTop: 0, // tidak ada padding dinamis
        marginBottom: 0
    }
})

const FormD = ({ dataDisposisi, datappm, qrImage }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [dataHc, setDataHc] = useState(null)
    // const [dataHcDetil, setDataHcDetil] = useState([])
    const [upt, setUpt] = useState(null)
    const [negaraTujuan, setNegaraTujuan] = useState(null)
    const [pelMuat, setPelMuat] = useState(null)
    const [pelBongkar, setPelBongkar] = useState(null)
    const [ppmDetil, setPpmDetil] = useState([])
    // const [jumlahKemasan, setJumlahKemasan] = useState(null)
    // const [uraianKemasan, setUraianKemasan] = useState(null)
    const [ppmKontainer, setPpmKontainer] = useState([])
    const [ppmMutu, setPpmMutu] = useState({})
    // const [ppmMutuArea, setPpmMutuArea] = useState(null)
    const [ppmMutuProd, setPpmMutuProd] = useState([])
    const [ppmKemasan, setPpmKemasan] = useState([])

    useEffect(() => {
        if (!datappm) return
        const fetchAllData = async () => {
            try {
                let jsonMutuPK = {
                    nomorAju: datappm.nomorAju,
                    noProses: dataDisposisi.noTugas
                }
                const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
                setDataHc(resHc.data)

                const resUpt = await userService.getUptById(datappm.kdUpt)
                // console.log(resUpt)
                setUpt(resUpt.data)

                const resNeg = await masterService.getNegaraById(datappm.negaraPartner)
                setNegaraTujuan(resNeg.data)

                const jsonPelMuat = {
                    jnsPelabuhan: "D",
                    kodePelabuhan: datappm.pelabuhanMuat
                }
                const resPelDn = await masterService.getPelabuhanById(JSON.stringify(jsonPelMuat))
                setPelMuat(resPelDn.data)

                const jsonPelLn = {
                    jnsPelabuhan: "L",
                    kodePelabuhan: datappm.pelabuhanBongkar
                }
                const resPelLn = await masterService.getPelabuhanById(JSON.stringify(jsonPelLn))
                setPelBongkar(resPelLn.data)

                const resDetil = await transaksiService.listPpmDetilAll(datappm.nomorAju)
                setPpmDetil(resDetil.data.data)

                const resMutu = await transaksiService.getPpmMutuById(datappm.nomorAju)
                setPpmMutu(resMutu.data)

                // const resMutuProd = await transaksiService.listPpmMutuProd(datappm.nomorAju, 0, 10)
                // setPpmMutuProd(resMutuProd.data.data)
                const resMutuProd = await transaksiService.listPpmMutuProdAll(datappm.nomorAju)
                setPpmMutuProd(resMutuProd.data.data)

                // const resKemasan = await transaksiService.listPpmKemasan(datappm.nomorAju, 0, 3)
                // setJumlahKemasan(resKemasan.data.data[0].jumlah)
                // const resUraianKemasan = await masterService.getKemasanById(resKemasan.data.data[0].kodeKemasan)
                // setUraianKemasan(resUraianKemasan.data.uraianKemasan)

                const resKemasanAll = await transaksiService.listPpmKemasanAll(datappm.nomorAju)
                setPpmKemasan(resKemasanAll.data.data)

                const resKontainer = await transaksiService.listPpmContainerAll(datappm.nomorAju)
                setPpmKontainer(resKontainer.data.data)

            } catch (error) {
                console.log(error)
            }
        }
        fetchAllData()
    }, [datappm, transaksiService, masterService, userService, dataDisposisi])

    return (
        <Document>
            <Page size="LEGAL" style={styles.page}>
                <View style={styles.sectionHeader} fixed>
                    <View style={styles.headingBetween}>
                        <View style={styles.headingRow}>
                            <Text style={styles.textHeading}>I. Consignment Information / </Text>
                            <Text style={styles.textHeadingItalic}>Informasi Pengiriman</Text>
                        </View>
                        <View style={styles.headingRow}>
                            <Text style={styles.textHeading}>Reference No / </Text>
                            <Text style={styles.textHeadingItalic}>No. Referensi : </Text>
                            <Text style={styles.textHeading}>{dataHc !== null ? dataHc.noHcMutu : ''}</Text>
                        </View>
                    </View>
                    {/* First Table */}
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Name of Consignor / </Text>
                                    <Text style={styles.italicText}>Nama Pengirim :</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.nmPengirim : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableCol}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Name of Consignee / </Text>
                                    <Text style={styles.italicText}>Nama Penerima : </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.nmPenerima : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Address / </Text>
                                    <Text style={styles.italicText}>Alamat : </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.alPengirim : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableCol}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Address /</Text>
                                    <Text style={styles.italicText}>Alamat : </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.alPenerima : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Tel / </Text>
                                    <Text style={styles.italicText}>Telp : </Text>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.telpUpi : ''}</Text>
                                </View>
                            </View>
                            <View style={styles.tableCol}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Tel / </Text>
                                    <Text style={styles.italicText}>Telp : </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '40%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.text, { textDecoration: "underline" }]}>Competent Authority The Exporting Country / </Text>
                                    <Text style={[styles.italicText, { textDecoration: "underline" }]}>Otoritas Kompeten Negara Eksportir</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '2%' }]}>
                                <Text style={styles.text}>:</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '58%' }]}>
                                <Text style={styles.text}>MARINE AND FISHERIES QUALITY ASSURANCE AGENCY (MFQAA)</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Address / </Text>
                                    <Text style={styles.italicText}>Alamat : </Text>
                                    <Text style={styles.text}>Jl. Medan Merdeka Timur No. 16, Jakarta. Telp. +6221-3520351</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '18%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Inspection Agency</Text>
                                    <Text style={styles.italicText}>Badan Pemeriksaan</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '1%' }]}>
                                <Text style={styles.text}>:</Text>
                            </View>
                            <View style={[styles.tableCol, { width: '70%' }]}>
                                <Text style={styles.text}>{upt !== null ? upt.nmInggris : '-'}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Tel / </Text>
                                    <Text style={styles.italicText}>Telp</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Description of Goods</Text>
                                <Text style={styles.italicText}>Kondisi Barang :</Text>
                                <Text style={[styles.text]}>{ppmMutu !== null ? ppmMutu.mutuDesk : ''}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Temperature of product</Text>
                                <Text style={styles.italicText}>Temperatur barang : </Text>
                                <Text style={[styles.text]}>{ppmMutu !== null ? ppmMutu.mutuTemp : ''}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Weight Declare (kg)</Text>
                                <Text style={styles.italicText}>Berat Timbangan (kg)</Text>
                                <Text style={[styles.text]}>{dataHc !== null ? dataHc.bruto : ''}</Text>
                            </View>
                            <View style={styles.tableCol}>
                                <View style={styles.tableRow}>
                                    <View style={[styles.tableCol, { width: "20%" }]} >
                                        <Text style={[styles.text, { textDecoration: "underline" }]}>Ambient</Text>
                                        <Text style={styles.italicText}>Ruang</Text>
                                    </View>
                                    {
                                        ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuTempTipe === '1' &&
                                        <View style={[styles.tableCol, { width: "20%" }]}>
                                            <Image src={imgCheck} style={styles.checkicon} />
                                        </View>
                                    }
                                    <View style={[styles.tableCol, { width: "20%" }]}>
                                        <Text style={[styles.text, { textDecoration: "underline" }]}>Chilled</Text>
                                        <Text style={styles.italicText}>Dingin</Text>
                                    </View>
                                    {
                                        ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuTempTipe === '2' &&
                                        <View style={[styles.tableCol, { width: "20%" }]}>
                                            <Image src={imgCheck} style={styles.checkicon} />
                                        </View>
                                    }
                                    <View style={[styles.tableCol, { width: "20%" }]}>
                                        <Text style={[styles.text, { textDecoration: "underline" }]}>Frozen</Text>
                                        <Text style={styles.italicText}>Beku</Text>
                                    </View>
                                    {
                                        ppmMutu !== null && ppmMutu !== undefined && ppmMutu.mutuTempTipe === '3' &&
                                        <View style={[styles.tableCol, { width: "20%" }]}>
                                            <Image src={imgCheck} style={styles.checkicon} />
                                        </View>
                                    }
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "100%" }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Commodities certified for :</Text>
                                <Text style={styles.italicText}>Sertifikat Komoditi untuk</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text>&nbsp;</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "25%" }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Human consumption : </Text>
                                <Text style={styles.italicText}>Dikonsumsi manusia</Text>
                            </View>
                            {
                                datappm !== null && datappm.peruntukan === '1' &&
                                <View style={[styles.tableCol, { width: "10%" }]}>
                                    <Image src={imgCheck} style={styles.checkicon} />
                                </View>
                            }
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "20%" }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Place of Destination (port) : </Text>
                                <Text style={styles.italicText}>Tempat Tujuan (pelabuhan)</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "20%" }]}>
                                <Text style={[styles.text]}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : '-'}, {negaraTujuan !== null ? negaraTujuan.uraianNegara : ''}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1 }]}>
                                <Text style={styles.text}>No.</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Species (Scientific Name)/</Text>
                                <Text style={styles.italicText}>Spesies (Nama Latin)</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Type of packages/</Text>
                                <Text style={styles.italicText}>Jenis Kemasan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Number of packages/</Text>
                                <Text style={styles.italicText}>Nomor Kemasan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Net weight (kg)</Text>
                                <Text style={styles.italicText}>Berat Bersih (kg)</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "23%" }]}>
                                <Text style={[styles.text, { textDecoration: "underline" }]}>Date (period) of Production</Text>
                                <Text style={styles.italicText}>Tanggal (Periode) Produksi</Text>
                            </View>
                        </View>
                        {
                            ppmDetil.length <= 3 ?
                                (
                                    ppmDetil.map((detil, index) => {
                                        return (
                                            <>
                                                <View key={index} style={[styles.tableRow]}>
                                                    <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                        <Text style={styles.text}>{detil.trPpkDtlPK.seri}</Text>
                                                    </View>
                                                    <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                        <Text style={[styles.italicText]}>{detil.namaLatin}</Text>
                                                    </View>
                                                    {
                                                        index === 0 ?
                                                            (
                                                                <>
                                                                    <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                        {
                                                                            ppmKemasan.map((kms, idxKms) => {
                                                                                return (
                                                                                    <>
                                                                                        <Text key={idxKms} style={[styles.text]}>{<Kemasan id={kms.kodeKemasan} />}</Text>
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                        {
                                                                            ppmKemasan.map((kms, idxKms) => {
                                                                                return (
                                                                                    <>
                                                                                        <Text key={idxKms} style={[styles.text]}>{kms.jumlah}</Text>
                                                                                    </>
                                                                                )
                                                                            })
                                                                        }
                                                                    </View>
                                                                </>
                                                            ) :
                                                            (
                                                                <>
                                                                    <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 0 }]}>
                                                                        <Text style={[styles.text]}></Text>
                                                                    </View>
                                                                    <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 0 }]}>
                                                                        <Text style={[styles.text]}></Text>
                                                                    </View>
                                                                </>
                                                            )
                                                    }
                                                    <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                        <Text style={[styles.text]}>{detil.jumlah}</Text>
                                                    </View>
                                                    {
                                                        index === 0 ?
                                                            (
                                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                                    {
                                                                        ppmMutuProd.map((mutuProd, index) => {
                                                                            return (
                                                                                <Text key={index} style={[styles.text]}>
                                                                                    {mutuProd.mutuProdTgl}
                                                                                </Text>
                                                                            )
                                                                        })
                                                                    }
                                                                </View>

                                                            ) :
                                                            (
                                                                <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 0 }]} />
                                                            )
                                                    }
                                                </View>
                                            </>
                                        )
                                    })
                                ) :
                                (
                                    <>
                                        <View style={[styles.tableRow]}>
                                            <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={styles.text}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.italicText]}>See Appendix</Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "16%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "19%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "15%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "23%", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                                <Text style={[styles.text]}></Text>
                                            </View>
                                        </View>
                                    </>
                                )
                        }
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Name of the Establishment(Producer)/</Text>
                                    <Text style={styles.italicText}>Nama UPI Produsen : </Text>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.nmUpi : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Address / </Text>
                                    <Text style={styles.italicText}>Alamat : </Text>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.alUpi : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Approval Number/</Text>
                                    <Text style={styles.italicText}>Nomor Persetujuan : </Text>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.noRegUpi : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>EU Approval Number (if available)/</Text>
                                    <Text style={styles.italicText}>Nomor Persetujuan UE (jika ada) : </Text>
                                    <Text style={styles.text}>{ppmMutu !== null ? ppmMutu.upiNoRegUe : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '25%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Container No/</Text>
                                    <Text style={styles.italicText}>No. Kontainer : </Text>
                                    {
                                        ppmKontainer !== undefined && ppmKontainer !== null &&
                                        ppmKontainer.map((kont, index) => {
                                            return (
                                                <>
                                                    <Text style={styles.text}>
                                                        {kont.nomor} ;
                                                    </Text>
                                                </>
                                            )
                                        })
                                    }
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '25%', borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Bill of Lading No/</Text>
                                    <Text style={styles.italicText}>No Dokumen Muat: </Text>
                                    <Text style={styles.text}>{datappm !== null ? (<GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'705'} /> === '' ? <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'705'} /> : <GetDokumen nomorAju={datappm.nomorAju} idJnsDok={'704'} />) : ''}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '25%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Seal No/</Text>
                                    <Text style={styles.italicText}>No Segel : </Text>
                                    {
                                        ppmKontainer !== undefined && ppmKontainer !== null &&
                                        ppmKontainer.map((kont, index) => {
                                            return (
                                                <>
                                                    <Text style={styles.text}>
                                                        {kont.nomorSegel};
                                                    </Text>
                                                </>
                                            )
                                        })
                                    }
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '25%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Mean of Conveyance/</Text>
                                    <Text style={styles.italicText}>Cara Pengiriman : </Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.nmTrans : ''} / Voyage : {dataHc !== null ? dataHc.noFlight : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '50%', borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Place of Dispatch (port)/</Text>
                                    <Text style={styles.italicText}>Tempat Pengiriman (pelabuhan): </Text>
                                    <Text style={styles.text}>{pelMuat !== null ? pelMuat.uraianPelabuhan : '-'}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '50%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Place of Destination (port)/</Text>
                                    <Text style={styles.italicText}>Tempat Tujuan (pelabuhan): </Text>
                                    <Text style={styles.text}>{pelBongkar !== null ? pelBongkar.uraianPelabuhan : '-'}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '50%', borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}></Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '50%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}></Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[styles.table, { borderBottomWidth: 1 }]}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '50%', borderRightWidth: 1 }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Date of Dispatch /</Text>
                                    <Text style={styles.italicText}>Tanggal Pengiriman : </Text>
                                </View>
                            </View>
                            <View style={[styles.tableCol, { width: '50%' }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglBerangkat) : ''}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.headingBetween}>
                        <View style={styles.headingRow}>
                            <Text style={styles.textHeading}>II. Health Attestation/</Text>
                            <Text style={styles.textHeadingItalic}>Pernyataan Kesehatan</Text>
                        </View>
                    </View>
                    <View style={styles.headingBetween}>
                        <View style={styles.headingRow}>
                            <Text style={styles.textHeading}>This is to certify that/</Text>
                            <Text style={styles.textHeadingItalic}>Dengan ini menerangkan bahwa :</Text>
                        </View>
                    </View>
                    <View style={styles.tableNoBorder}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColNoPadding, { width: "3%" }]}>
                                <Text style={[styles.text, { fontSize: 7 }]}>1. </Text>
                            </View>
                            <View style={[styles.tableColNoPadding, { width: "97%" }]}>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.text, { fontSize: 7 }]}>The above fishery product come from the establishment approved by the Marine And Fisheries Quality Assurance Agency and met EU requirements (*)/</Text>
                                    <Text style={[styles.text, { fontSize: 7 }]}>Produk perikanan diatas berasal dari Unit Pengolahan Ikan (UPI) disetujui oleh Badan Pengendalian Dan Pengawasan Mutu Hasil Kelautan Dan Perikanan dan sesuai persyaratan UE(*)</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.text, { fontSize: 7 }]}>(*) In case the product would be used for further processing to export to EU, the underlined clause should be kept./</Text>
                                    <Text style={[styles.text, { fontSize: 7 }]}> (*) Jika produk akan digunakan untuk pengolahan lebih lanjut untuk ekspor ke UE, ketentuan yang digaris bawahi harus berlaku.</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColNoPadding, { width: "3%" }]}>
                                <Text style={[styles.text, { fontSize: 7 }]}>2. </Text>
                            </View>
                            <View style={[styles.tableColNoPadding, { width: "97%" }]}>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.text, { fontSize: 7 }]}>The product were produced, packed, stored and transported under sanitary condition, which were under the supervision and inspection of the Marine And Fisheries Quality Assurance Agency.</Text>
                                    <Text style={[styles.text, { fontSize: 7 }]}>Produk telah diproduksi, dikemas, disimpan dan diangkut dalam keadaan bersih/sehat, yang mana berada di bawah pengawasan dan pemeriksaan Badan Pengendalian Dan Pengawasan Mutu Hasil Kelautan Dan Perikanan.</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColNoPadding, { width: "3%" }]}>
                                <Text style={[styles.text, { fontSize: 7 }]}>3. </Text>
                            </View>
                            <View style={[styles.tableColNoPadding, { width: "97%" }]}>
                                <View style={styles.tableRow}>
                                    <Text style={[styles.text, { fontSize: 7 }]}>The product were inspected by Inspection Agency and not found any pathogenic bacteria, harmful substances and fit for human consumption./</Text>
                                    <Text style={[styles.text, { fontSize: 7 }]}>Produk telah diperiksa oleh Badan Pemeriksa dan tidak ditemukan adanya bakteri pathogen, unsur-unsur yang membahayakan dan aman untuk konsumsi manusia.</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableNoBorder}>
                        <View style={[styles.tableRow, { marginTop: 5, marginBottom: 60 }]}>
                            <View style={[styles.tableColNoPadding, { width: "50%" }]}>
                            </View>
                            <View style={[styles.tableColNoPadding, { width: "50%" }]}>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Date of Issue/ </Text>
                                    <Text style={styles.italicText}>Dikeluarkan tanggal: </Text>
                                    <Text style={styles.text}>{dataHc !== null ? formatDateStringLocalDate(dataHc.tglHc) : ''}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableColNoPadding, { width: "50%" }]}>
                            </View>
                            <View style={[styles.tableColNoPadding, { width: "40%" }]}>
                                <View style={[styles.tableRow, { width: "100%" }]}>
                                    <Text style={styles.text}>{dataHc !== null ? dataHc.nmPejabat : ''}</Text>
                                </View>
                                <View style={styles.tableRow}>
                                    <Text style={styles.text}>Signature of Official Inspector/</Text>
                                    <Text style={styles.italicText}>Tandatangan Inspektur Mutu</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
            {
                ppmDetil.length > 3 &&
                <>
                    <DraftAppendix ppmdetil={ppmDetil} datahc={dataHc} upt={upt} dataDisposisi={dataDisposisi} qrImage={qrImage} />
                </>
            }
        </Document>
    )
}

export default FormD